import React from "react";

function Work() {
  return (
    <div className="work-section">
      <h1>Our Work & Projects</h1>

      <div className="gallery">

        {/* FOTO */}
        <img src="/work/work1.jpg" alt="HVAC Project 1" />
        <img src="/work/work2.jpg" alt="HVAC Project 2" />
        <img src="/work/work3.jpg" alt="HVAC Project 3" />
        <img src="/work/work4.jpg" alt="HVAC Project 4" />

        {/* VIDEO */}
        <video controls>
          <source src="/work/work5.mp4" type="video/mp4" />
        </video>

        <video controls>
          <source src="/work/work6.mp4" type="video/mp4" />
        </video>

        <video controls>
          <source src="/work/work7.mp4" type="video/mp4" />
        </video>

        <video controls>
          <source src="/work/work8.mp4" type="video/mp4" />
        </video>

        <video controls>
          <source src="/work/work9.mp4" type="video/mp4" />
        </video>

      </div>
    </div>
  );
}

export default Work;
